import React, { Fragment, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import FilterBar from "./FilterBar";
import SchedulerGrid from "./SchedulerGrid";
import { MOCK_TASKS, SUMMARY_STATS } from "./mockTasks";

function getMonday(date) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    const day = d.getDay();
    d.setDate(d.getDate() - day + (day === 0 ? -6 : 1));
    return d;
}

/* ── Inline stat item ── */
const Stat = ({ label, value }) => (
    <div style={{ display: "flex", alignItems: "baseline", gap: 6 }}>
        <span style={{ fontSize: 12, color: "#64748b", fontWeight: 500 }}>{label}:</span>
        <span style={{ fontSize: 20, fontWeight: 800, color: "#1e293b", lineHeight: 1 }}>
            {String(value).padStart(2, "0")}
        </span>
    </div>
);

function getIsEmployee() {
    try {
        const parsed = JSON.parse(localStorage.getItem("userDetails") || "{}");
        const role = (parsed?.roleName || parsed?.role || "").toLowerCase();
        return role.includes("employee") || role.includes("resource");
    } catch {
        return false;
    }
}

const ClientView = () => {
    const isEmployee = getIsEmployee();
    const [weekStart, setWeekStart] = useState(() => getMonday(new Date()));
    const [filterResource, setFilterResource] = useState("");
    const [filterProject, setFilterProject] = useState("");
    const [searchText, setSearchText] = useState("");

    const filteredTasks = useMemo(() => {
        return MOCK_TASKS.filter((t) => {
            if (filterResource && !t.team.includes(filterResource)) return false;
            if (filterProject && t.title !== filterProject) return false;
            if (searchText) {
                const q = searchText.toLowerCase();
                if (
                    !t.title.toLowerCase().includes(q) &&
                    !t.team.some((m) => m.toLowerCase().includes(q))
                )
                    return false;
            }
            return true;
        });
    }, [filterResource, filterProject, searchText]);

    const uniqueProjectCount = new Set(filteredTasks.map((t) => t.title)).size;

    const handlePrev = () => {
        const d = new Date(weekStart);
        d.setDate(d.getDate() - 7);
        setWeekStart(d);
    };

    const handleNext = () => {
        const d = new Date(weekStart);
        d.setDate(d.getDate() + 7);
        setWeekStart(d);
    };

    return (
        <Fragment>
            

            

            {/* ── Filter bar ── */}
            <FilterBar
                totalCount={uniqueProjectCount || SUMMARY_STATS.totalProjects}
                weekStart={weekStart}
                onPrev={handlePrev}
                onNext={handleNext}
                filterResource={filterResource}
                onResourceChange={(v) => setFilterResource(v)}
                filterProject={filterProject}
                onProjectChange={(v) => setFilterProject(v)}
            />

            {/* ── Scheduler grid ── */}
            <SchedulerGrid tasks={filteredTasks} weekStart={weekStart} isEmployee={isEmployee} />

            
        </Fragment>
    );
};

export default ClientView;
